import { APIEndpoints } from "../../constants";
import { APIGet, APIPost, getAuthHeaders, APIResponse } from "../api/common.service";
import {
  ChatInboxResponseData,
  COQLRequest,
  GetChatMessagesResponseData,
  SendChatMessageRequest,
  MarkReadRequest,
  UnreadCountResponseData,
} from "../../types";

export function GetChatInbox(): Promise<APIResponse<ChatInboxResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIGet<ChatInboxResponseData>(
      APIEndpoints.GetChatInbox,
      headers
    )
  );
}

export function GetChatMessages(
  body: COQLRequest,
  options?: { skipLoader?: boolean }
): Promise<APIResponse<GetChatMessagesResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<GetChatMessagesResponseData>(
      APIEndpoints.GetTeacherSubmittedArtworks,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
      options
    )
  );
}

export function SendChatMessage(
  body: SendChatMessageRequest
): Promise<APIResponse<unknown>> {
  return getAuthHeaders().then((headers) =>
    APIPost<unknown>(
      APIEndpoints.SendChatMessage,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function MarkMessagesRead(
  body: MarkReadRequest
): Promise<APIResponse<unknown>> {
  return getAuthHeaders().then((headers) =>
    APIPost<unknown>(
      APIEndpoints.MarkMessagesRead,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function GetUnreadChatCount(
  options?: { skipLoader?: boolean }
): Promise<APIResponse<UnreadCountResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIGet<UnreadCountResponseData>(
      APIEndpoints.GetUnreadChatCount,
      headers,
      undefined,
      undefined,
      options
    )
  );
}
